/***
 * Geo detection file
 */
import { AnalyticsData, GetAnalytics } from "./analytics";
import { getCookie, setCookie } from "./tools";

let analyticsEmails = {
  "google": "email@legis-s.ru",
  "yandex": "info@legis-s.ru",
  "yandexcpc": "sales@legis-s.ru",
  "googlecpc": "post@legis-s.ru",
}

function getEmailFromSource(source: AnalyticsData["current"]): string | undefined {
  // Do not track direct traffic
  if (source.src == "(direct)") return;
  
  if ( source.src == "google") {
    return  (source.mdm == "cpc")? analyticsEmails["googlecpc"]: analyticsEmails["google"];
  }
  if ( source.src == "yandex" || source.src == "yandex.ru") {
    return  (source.mdm == "cpc")? analyticsEmails["yandexcpc"]: analyticsEmails["yandex"];
  }
}

// Switch city based on id
export function SwitchCity(cityId: string) {
  setCookie("region", cityId, 99);
}

/**
 * Cities toggler initializer
 */
function toggleCities() {
  let button = $("#city");
  let items = $(".nav__wrapper-items-right-menu-item");
  let menu = $(".nav__wrapper-items-right-menu");
  let label = $("#city");

  // Event to open the regional menu on desktop
  button.on("click", function () {
    $(this).toggleClass("clicked");
    menu.toggleClass("nav__wrapper-items-right-menu-active");
  });

  // Set city switcher cities events
  for (let i = 0; i < Array.from(items).length; i++) {
    $(items[i]).on("click", function (event, element) {
      // Switch city
      setCookie("selected_region", "yes", 1);
      items.removeClass("nav__wrapper-items-right-menu-item-active");
      $(this).addClass("nav__wrapper-items-right-menu-item-active");
      menu.removeClass("nav__wrapper-items-right-menu-active");
      button.removeClass("clicked");
      let cityId = $(this).attr("data-name");
      SwitchCity(cityId);

      // TODO: Remove stuff like this from it
      window.location.reload();
    });
  }
}

/**
 * Changes UI for selected region
 * @param region selected region
 */
function UTMEmails() {
  let email;
  // If source in analytics, use analytics
  let analytics = GetAnalytics();
  let current = analytics.current;
  let source_email = getEmailFromSource(current);
  if (source_email) {
    email = source_email
  } else {
    return;
  }



  let headerEmail = $("#headerEmail");
  let footerEmail = $("#footerEmail");

  // Override contacts emails
  let contactsEmails = document.querySelectorAll<HTMLAnchorElement>(".contacts_city #email");
  if (contactsEmails.length >0 ){
    contactsEmails.forEach(item =>{
      item.setAttribute("href", "mailto:" + email )
      item.innerHTML = email;
    })
  }

  headerEmail.text(email);
  headerEmail.attr("href", "mailto:" + email);
  footerEmail.text(email);
  footerEmail.attr("href", "mailto:" + email);
}

$(() => {
  // Check the region
  // check_region();
  UTMEmails();
  // // Enable city toggle
  toggleCities();
});
